import React, { useState } from 'react';
import { useT } from 'hooks/Locale/useT';
import './styles.scss';

type CopyValueProps = {
    value: string | null;
    fullWidth?: boolean;
};

const CopyValue: React.FC<CopyValueProps> = ({ value, fullWidth = false }: CopyValueProps) => {
    const [isCopied, setIsCopied] = useState<boolean>(false);
    const t = useT();

    const handleCopy = (): void => {
        if (!value) return;
        if (!navigator?.clipboard?.writeText) return;

        navigator.clipboard.writeText(value).then(() => {
            setIsCopied(true);
            window.setTimeout(() => {
                setIsCopied(false);
            }, 1500);
        });
    };

    return (
        <div className={`copy-value justify-between${fullWidth ? ' copy-value--full' : ''}`}>
            <span className="copy-value__text">{value ?? '-'}</span>
            <button
                type="button"
                className="copy-value__button"
                onClick={handleCopy}
                disabled={!value}
            >
                {isCopied ? t('general.copied') : t('general.copy')}
            </button>
        </div>
    );
};

export default CopyValue;
